<template>
    <div
        style="height: 100%"
        class="transition-ease-in-out"
        :class="['dnd-area', 'text-center', fileUpload.dnd_over.value ? 'dnd-over' : 'dnd-out']"
        @dragover.stop.prevent="fileUpload.upload_dragover"
        @dragleave.stop.prevent="fileUpload.upload_dragleave"
        @drop.stop.prevent="uploadDrop"
    >
        <div style="display: initial; position: absolute; opacity: 0;">
            <input
                id="userfile438"
                ref="userfile438"
                type="file"
                name="userfile438"
                @change="uploadChange"
            />
        </div>
        <div
            v-if="fileUpload.upload_state.running"
            class="px-8 d-flex flex-column justify-center align-center"
            style="height: 100%"
        >
            <PrimaryLoadingBar :value="fileUpload.upload_progress" />
            <div class="mt-3">
                <div v-if="fileUpload.upload_state.total_files === 0">{{ $t("Waiting for files") }}</div>
                <div v-else-if="fileUpload.upload_state.total_files === fileUpload.upload_state.uploaded_files">
                    {{ $t("Uploaded") }}
                </div>
                <div v-else>
                    {{ $t("Uploading...") }}
                </div>
            </div>
        </div>
        <label
            v-else
            style="height: 100%"
            for="userfile438"
        >
            <div style="height: 100%" class="d-flex align-center justify-center flex-column">
                <primary-button @click="userfile438.click()">
                    {{ $t('Upload file') }}
                </primary-button>
                <div class="body-2 mt-2 font-weight-medium">{{ $t('...or drag a file here') }}</div>
                <div class="body-2 mt-5">{{ $t("Only Excel (.xls, .xlsx) file types are supported") }}</div>
            </div>
        </label>
    </div>
</template>

<script>
import errorDialog from "@/views/ErrorDialog/errorDialog"
import Vue from "vue";
import { computed, ref } from "@vue/composition-api";
import { $t } from "@/i18n";
import { Router } from "@/composables/Router";
import AppModule from "../../../../store/modules/app";
import DetailViewHeader from "../../../../components/DetailViewHeader";
import FileUpload from "../../../../composables/FileUpload";
import ApiImport from "@/api/integration/import"
import PrimaryLoadingBar from "@/components/LoadingBar/PrimaryLoadingBar";

export default {
    name: "FileUploadArea",
    components: {
        PrimaryLoadingBar,
        DetailViewHeader
    },
    props: {
        fileUpload: {
            type: Object,
            required: true
        },
        uploadDrop: {
            type: Function,
            required: true
        },
        uploadChange: {
            type: Function,
            required: true
        }
    },
    setup(props) {
        const userfile438 = ref(null)

        return {
            userfile438
        }
    }
};
</script>
